import * as angular from 'angular';
import * as _ from 'lodash';

import { ShapePoint, IValueViewModel, ShapePointReference, ComponentDefinition, ISortConfiguration } from '../../../models';
import { Helper } from '../../../common';

interface FormController extends angular.IFormController {

}

class ShapePointsController implements angular.IComponentController {
    canBind: boolean;
    formController: FormController;
    isLoading: boolean;
    loadingMessage: string;
    points: ShapePoint[];
    sortConfig: ISortConfiguration;
    viewModels: { [guid: string]: IValueViewModel };

    static $inject = [];

    $onInit() {
        this.sortConfig = {
            animation: 150,
            handle: '.drag-handle',
            onSort: evt => this.sort()
        };
    }

    dropX(data: { itemId: string }, point: ShapePoint) {
        const ref = point.x;
        this.mapSeries(data.itemId, ref);

    }
    
    dropY(data: { itemId: string }, point: ShapePoint) {
        const ref = point.y;
        this.mapSeries(data.itemId, ref);
    }

    remove(guid: string) {
        _.remove(this.points, p => p.guid === guid);
        this.formController.$setDirty();
    }

    duplicate(point: ShapePoint) {
        const newPoint = angular.copy(point);
        newPoint.guid = Helper.getGuid();
        this.points.push(newPoint);
        this.formController.$setDirty();
    }

    private sort() {
        this.formController.$setDirty();
    }

    private mapSeries(guid: string, point: ShapePointReference) {
        point.seriesGuid = guid;
        point.type = 'serie';
        point.valueType = 'average';
        point.isBoundToGroup = this.canBind;
        this.formController.$setDirty();
    }
}

export const wtShapePoints: ComponentDefinition = {
    componentId: 'wtShapePoints',
    controller: ShapePointsController,
    template: require('./shapePoints.component.html'),
    controllerAs: 'vm',
    bindings: {
        points: '<',
        viewModels: '<',
        onDrop: '&',
        formController: '=?',
        canBind: '<?'
    }
};